export default "__VITE_ASSET__yQUrJEFt__"